import axios from 'axios';
import { formatDateTime } from '../../utils/dates';

// Commandes (orders page) — data access + shared vocabulary. Mirrors
// Backend app/api/commerce.py and app/services/commerce_orders_service.py.

export const API = '/api/commerce';

const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } });

export const get = (path, params) => axios.get(`${API}${path}`, { ...authHeaders(), params });
export const post = (path, body) => axios.post(`${API}${path}`, body, authHeaders());
export const put = (path, body) => axios.put(`${API}${path}`, body, authHeaders());
export const patch = (path, body) => axios.patch(`${API}${path}`, body, authHeaders());
export const del = (path) => axios.delete(`${API}${path}`, authHeaders());

export const fail = (error, fallback) => {
    const detail = error?.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
    return fallback;
};

export const ORDER_STATUSES = ['pending', 'preparing', 'shipped', 'delivered', 'incident', 'returned', 'cancelled'];
export const SOURCES = ['api', 'shopify', 'prestashop'];
export const PROBLEM_KINDS = ['stall', 'hazard', 'hard_48h', 'no_first_scan', 'carrier_exception', 'silent_lost'];

export const STATUS_TONE = {
    pending: 'muted', preparing: 'blue', shipped: 'accent', delivered: 'success',
    incident: 'danger', returned: 'warning', cancelled: 'muted',
};

// Parcel monitor status of one shipment (parcels collection).
export const PARCEL_TONE = {
    pending: 'muted', in_transit: 'accent', delivered: 'success', returned: 'warning', problem: 'danger', silent_lost: 'danger',
};

// dateStyle/timeStyle cannot mix with formatDateTime's field options: use its default.
export const formatWhen = (value, lang) => (value ? formatDateTime(value, {}, lang === 'en' ? 'en-GB' : 'fr-FR') : '—');

export const formatMoney = (amount, currency = 'EUR', lang = 'fr') => {
    if (amount === null || amount === undefined || amount === '') return '—';
    try {
        return Number(amount).toLocaleString(lang, { style: 'currency', currency: currency || 'EUR' });
    } catch (e) {
        return `${Number(amount).toFixed(2)} ${currency || ''}`.trim();
    }
};

export const copyText = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (e) {
        return false;
    }
};

// The public API base the tenant's systems call (same origin as the app).
export const publicBase = () => `${window.location.origin}${API}/v1`;
